import { REDUX_ACTIONS, GAME_ID, PROJECTOR_ANIMATIONS } from 'a/pickyGoblins/data/constants';

const initState = {
  animation: '',
  playLips: false,
  letter: '',
};

const projectorReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.PROJECTOR_SET_ANIMATION:
      return {
        ...state,
        animation: payload,
        playLips: ((state.animation === PROJECTOR_ANIMATIONS.OPEN && payload === PROJECTOR_ANIMATIONS.OPEN)
          ? !state.playLips
          : state.playLips
        ),
      };

    case REDUX_ACTIONS.PROJECTOR_PLAYLIPS:
      return {
        ...state,
        playLips: !state.playLips,
      };

    case REDUX_ACTIONS.PROJECTOR_SET_TARGET_LETTER:
      return {
        ...state,
        letter: payload,
      };

    default:
      return state;
  }
};

export default projectorReducer;
